import { render, staticRenderFns } from "./r-trader-offer-rule-dialog.vue?vue&type=template&id=2b84dc5a&scoped=true"
import script from "./r-trader-offer-rule-dialog.vue?vue&type=script&lang=js"
export * from "./r-trader-offer-rule-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-trader-offer-rule-dialog.vue?vue&type=style&index=0&id=2b84dc5a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b84dc5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b84dc5a')) {
      api.createRecord('2b84dc5a', component.options)
    } else {
      api.reload('2b84dc5a', component.options)
    }
    module.hot.accept("./r-trader-offer-rule-dialog.vue?vue&type=template&id=2b84dc5a&scoped=true", function () {
      api.rerender('2b84dc5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/trader/r-trader-offer-rule-dialog.vue"
export default component.exports